import React from 'react'
import DataTable from '../../DataTable/DataTable'
import clsx from "clsx"

export default class EmailTab extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    var tabClasses = clsx({
      'active': this.props.active_tab == 'emails',
      'tab-pane': true
    });
    return (
      <div className={tabClasses} id="emails">     
        <div className="panel panel-default">
          <div className="panel-body container">
            <h3 className="panel-heading-text clear-left-padding">{`${I18n.t("sent_email")} - ${I18n.t("room_type")}: ${this.props.reservation_segment.room_type ? this.props.reservation_segment.room_type.name : ""}, ${I18n.t("source")}: ${this.props.reservation ? this.props.reservation.source : ""}`}</h3>
            <div className="table-wrap-panel" >
              <DataTable
                endpoint={this.props.sent_email_data_table_path}
                no_data_text={I18n.t('none')}
                date_format={this.props.date_format}
                time_format={this.props.time_format}
                inModal={true}
                />
            </div>
          </div>
        </div>
        <br />
        <div className="panel panel-default">
          <div className="panel-body container">
            <h3 className="panel-heading-text clear-left-padding">{I18n.t("scheduled_email")}</h3>
            <div className="table-wrap-panel" >
              <DataTable
                endpoint={this.props.scheduled_email_data_table_path}
                no_data_text={I18n.t('none')}
                date_format={this.props.date_format}
                time_format={this.props.time_format}
                inModal={true}
                />
            </div>
          </div>
        </div>
      </div>
    );
  };
};
